import { render, staticRenderFns } from "./SaveInline.vue?vue&type=template&id=1c630940&"
import script from "./SaveInline.vue?vue&type=script&lang=ts&"
export * from "./SaveInline.vue?vue&type=script&lang=ts&"
import style0 from "./SaveInline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports